import { FunctionComponent } from "react";
import { Api } from "service/api";
import { builderQueryParams } from "utils";

interface ICmbBrandsOperation {
    setterFunc?: Function,
    idFile: number,
    idUser?: number,
    idBrand?: number
}



export default class ServiceArchivo {

    static async get(setterFunc?:Function,idArchivo?:number) {
        const API = new Api();
        const URL = idArchivo ? `file/${idArchivo}` : 'file'
        const response: object | any | null = await API.get(URL);
        if (response) {
            let archivos: any = response;
            if (Array.isArray(response)) {
                archivos = response.map((d: any) => ({ ...d, estatus: d.idEstatus ? "Activo" : "Inactivo" }))
                setterFunc && setterFunc(archivos);
            } else {
                archivos = { ...response, estatus: response.idEstatus ? "Activo" : "Inactivo" };
            }
            return archivos
        }
    };
    
    static async getRelMarcaOperacion(setterFunc:Function,idArchivo:number) {
        const API = new Api();
        const URL = `file/${idArchivo}/rel-tipo-operacion`
        const response: object | any | null = await API.get(URL);
        if (response) {
            setterFunc(response);
            return response
        }
    };

    static async getMarcas( setterFunc : any, idUsuario : number) {
        const API = new Api();
        const URL = `file/brands-by-user-auth?idUsuario=${idUsuario}`
        const response: object | any | null = await API.get(URL);
        if (response) {
            const rtn = response.map((d: any) => ({ label: d.marca, value: d.idMarca }));
            setterFunc && setterFunc(rtn)
            return rtn;
        }
    };

    static async getTiposOperacion( setterFunc : any, brandId : number, idUsuario : number) {
        const API = new Api();
        const URL = `file/tipo-operacion-by-user-auth?idBrand=${brandId}&idUsuario=${idUsuario}`
        const response: object | any | null = await API.get(URL);
        if (response) {
            const rtn = response.map((d: any) => ({ label: d.tipoOperacion, value: d.idtipoOperacion }));
            setterFunc && setterFunc(rtn)
            return rtn;
        }
    };

    static async getFiles( setterFunc : any, brandId : number, idTipoOperacion : number, idUsuario : number) {
        const API = new Api();
        const URL = `file/relacion-brand-tipo-operacion?idBrand=${brandId}&idTipoOperacion=${idTipoOperacion}&idUsuario=${idUsuario}`
        const response: object | any | null = await API.get(URL);
        if (response) {
            const rtn = response.map((d: any) => ({ label: d.achivo, value: d.idArchivo, idRelacionArchivoMarcaTipoOp : d.idRelacionArchivoMarcaTipoOp }));
            setterFunc && setterFunc(rtn)
            return rtn;
        }
    };

    static async cbmReporteRelacion({ setterFunc }: any) {
        const API = new Api();
        const response: object | any | null = await API.get(`file/vistas-reportes`);
        if (response) {
            const relacion = response
                .map((d: any) => ({ label: d.Reporte, value: d.IdVista }));
            setterFunc(relacion);
        }
    };
    static async post({ data }: any) {
        const API = new Api();
        const response = await API.post(`file`, data);
        return response;
    };
    static async update(data:any,idArchivo:number) {
        const API = new Api();
        const response = await API.put(`file/${idArchivo}`, data);
        return response;
    };
    static async updateRelMarcaOperacion(data:any,idArchivo:number) {
        const API = new Api();
        const response = await API.put(`file/${idArchivo}/rel-tipo-operacion-marca`, data);
        return response;
    };


    //Relacion UsuariosArchivos
    static async getRelUsuariosArchivos(setterFunc:Function) {
        const API = new Api();
        const URL = `file/rel-file-user`
        const response: object | any | null = await API.get(URL);
        if (response) {
            setterFunc(response.map((d:any) => ({...d,estatus:d.idEstatus ? "Activo": "Inactivo"}) ));
            return response
        }
    };
    static async getRelUsuariosArchivosDetalle(idUsuario:number,setterFunc?:Function) {
        const API = new Api();
        const URL = `file/user/${idUsuario}/rel-archivo-marca-tipo-operacion`
        const response: object | any | null = await API.get(URL);
        if (response) {
            setterFunc && setterFunc(response);
            return response
        }
    };
    static async cbmTipoDato({ setterFunc }: any) {
        const API = new Api();
        const response: object | any | null = await API.get(`file/column-types`);

        if (response) {
            const tiposDatos = response
                .map((d: any) => ({ label: d.Descripcion, value: d.Valor }));
            setterFunc(tiposDatos);
        }
    };
    static async cbmUsuariosNoConfig({ setterFunc }: any) {
        const API = new Api();
        const response: object | any | null = await API.get(`file/filter/users`);

        if (response) {
            const rtn = response.map((d: any) => ({ label: d.nombre, value: d.idUsuario }));
            setterFunc(rtn);
            return rtn
        }
    }; 
    
    static async cbmFilesBrands(props:ICmbBrandsOperation) {
        const API = new Api();
        const $USER = props.idUser ? `?usuario=${props.idUser}` : ''
        const $URL = `file/${props.idFile}/filter/brands${$USER}`
        const response: object | any | null = await API.get($URL);
        if (response) {
            const rtn = response.map((d: any) => ({ label: d.marca, value: d.idMarca }));
            props.setterFunc && props.setterFunc(rtn);
            return rtn;
        }
    }; 
    static async cbmFilesBrandsOperations(props:ICmbBrandsOperation) {
        const API = new Api();
        const $USER = props.idUser ? `?usuario=${props.idUser}` : '';
        const $URL = `file/${props.idFile}/brand/${props.idBrand}/filter/tipo-operacion${$USER}`
        const response: object | any | null = await API.get($URL);
        if (response) {
            const rtn = response.map((d: any) => ({ label: d.tipoOperacion, value: d.idRelacionArchivoMarcaTipoOp }));
            props.setterFunc && props.setterFunc(rtn);
            return rtn
        }
    }; 
    static async updateRelUsuariosArchivos(data:any,idUsuario:number) {
        const API = new Api();
        const response = await API.put(`file/user/${idUsuario}/relation-user-file`, data);
        return response;
    };




    //Historio de Archivos

    static async getHistorico({setterFunc,params}:any) {
        const API = new Api();
        const $params = builderQueryParams(params);
        const URL = `file/historic${$params}`
        const response: object | any | null = await API.get(URL);
        if (response) {
            setterFunc(response);
            return response
        }
    };

    static async cmbBrandsOperation({ setterFunc }: any) {
        const API = new Api();
        const response: object | any | null = await API.get(`file/filter/brand-tipo-operacion`);
        if (response) {
            const relacion = response
                .map((d: any) => ({ label: d.marcaTipoOperacion, value: d.idRelacionArchivoMarcaTipoOp }));
            setterFunc(relacion);
        }
    };

    static async cmbFilesUser(setterFunc:Function){
        const API = new Api();
        const response: object | any | null = await API.get(`file/filter/files-user`);
        if (response) {
            const relacion = response
                .map((d: any) => ({ label: d.nombreArchivo, value: d.idArchivo }));
            setterFunc(relacion);
            return relacion
        }
    }
    static async cmbBrandsByUser({setterFunc,idFile}:any){
        const API = new Api();
        const response: object | any | null = await API.get(`file/${idFile}/filter/brands-by-user`);
        if (response) {
            const relacion = response
                .map((d: any) => ({ label: d.marca, value: d.idMarca }));
            setterFunc && setterFunc(relacion);
            return relacion
        }
    }
    static async cmbOperationsByUser({setterFunc,idFile,idBrand}:any){
        const API = new Api();
        const response: object | any | null = await API.get(`file/${idFile}/brand-by-user/${idBrand}/filter/tipo-operacion`);
        if (response) {
            const relacion = response
                .map((d: any) => ({ label: d.tipoOperacion, value: d.idTipoOperacion }));
            setterFunc && setterFunc(relacion);
            return relacion
        }
    }
    static async postUploadFile({ data }: any) {
        const API = new Api();
        const response = await API.postFormData(`file/upload-file`, data);
        return response;
    };

    static async getListVersions({setterFunc,idFileHead}:any){
        const API = new Api();
        const response: object | any | null = await API.get(`file/versions?idFileHead=${idFileHead}`);
        if (response) {
            setterFunc && setterFunc(response);
            return response
        }
    }
    static async cmbRelBrandOperation(setterFunc:Function){
        const API = new Api();
        const response: object | any | null = await API.get(`file/marca-usuario-tipo-operacion`);
        if (response) {
            const relacion = response
                .map((d: any) => ({ label: d.marcaTipoOperacion, value: d.idRelacionArchivoMarcaTipoOp }));
            setterFunc && setterFunc(relacion);
            return relacion
        }
    }
    static async cmbReporteUsuario(setterFunc:Function){
        const API = new Api();
        const response: object | any | null = await API.get(`file/reporte-usuario`);
        if (response) {
            const relacion = response
                .map((d: any) => ({ label: d.descripcion, value: d.idVista }));
            setterFunc && setterFunc(relacion);
            return relacion
        }
    }







}